import { $getQueryParams } from '@/utils';
import httpService from '@Utils/httpService';

const baseUrl = 'api/tasks';

export default {
  get(taskId,params) {
    const qParams = $getQueryParams(params);

    return httpService.get({
      url: baseUrl + `/${taskId}/history?` + qParams.toString(),
    });
  },
};
